<template>
  <div id="contenedor-listado-solicitudes-detalles">
    <v-simple-table>
      <template
        v-slot:default>
        <thead>
          <tr>
            <th>#</th>
            <th>Tipo</th>
            <th class="text-center">Número</th>
            <th>Núm. Factura</th>
            <th class="text-center">
              Fecha Factura
            </th>
            <th class="text-right">Monto</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <template
            v-for="(referencia, index) in referencias">
            <template>
              <tr
                :key="`referencia-${index}`">
                <td>
                  {{ (index + 1) }}
                </td>
                <td>
                  <v-chip
                    pill
                    :color="referencia.referencia.color"
                    dark>
                    {{ referencia.referencia.tipo }}
                  </v-chip>
                </td>
                <td align="center">
                  <v-chip
                    v-if="referencia.referencia.numero"
                    small>
                    {{ referencia.referencia.numero }}
                  </v-chip>
                </td>
                <td>
                  <b>
                    {{ referencia.numeroFactura }}
                  </b>
                </td>
                <td class="text-center">
                  {{ new Date(`${referencia.fechaFactura} 00:00:0`).toLocaleDateString() }}
                </td>
                <td align="right" class="font-weight-bold">
                  {{ referencia.importe | currency }}
                </td>
                <td>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="removerReferencia(index)">
                        <v-icon>
                          mdi-close
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>
                      Remover referencia
                    </span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </template>
          <template
            v-if="referencias.length <= 0">
            <tr>
              <td>
                1
              </td>
              <td>
                --
              </td>
              <td align="center">
                --
              </td>
              <td>
                --
              </td>
              <td align="center">
                --
              </td>
              <td align="right">
                {{ 0 | currency }}
              </td>
              <td></td>
            </tr>
          </template>
        </tbody>
        <tfoot class="grey lighten-4 font-weight-bold">
          <tr>
            <td
              colspan="5"
              align="right">
              TOTAL:
            </td>
            <td align="right">
              <v-chip>
                {{ total | currency }}
              </v-chip>
            </td>
            <td></td>
          </tr>
        </tfoot>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: 'ListadoSolicitudesDePagoDetalles',
  props: {
    referencias: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    removerReferencia(index) {
      this.$emit('removerReferencia', index);
    },
  },
  computed: {
    total() {
      return this.$sumar(this.referencias.map(({ importe }) => importe));
    },
  },
};
</script>

<style lang="scss">

</style>
